import {initializeApp} from 'firebase/app';
import {getAnalytics, logEvent, setUserId} from "firebase/analytics";

const config = {
    apiKey: process.env.REACT_APP_FB_CONFIG_API_KEY,
    authDomain: process.env.REACT_APP_FB_CONFIG_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FB_CONFIG_PROJECT_ID,
    messagingSenderId: process.env.REACT_APP_FB_CONFIG_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FB_CONFIG_APP_ID,
    measurementId: process.env.REACT_APP_FB_CONFIG_MEASUREMENT_ID
};

class AuditTrailService {
    constructor() {
        this.appName = 'admin';
        this.appVersion = process.env.REACT_APP_VERSION ? process.env.REACT_APP_VERSION : 'BETA'

        if (!!config.apiKey) {
            this.app = initializeApp(config);
            this.analytics = getAnalytics(this.app);
        }
    }

    setOrganization(org) {
        this.orgId = org? org._id : null;
    }

    setUser(user) {
        this.userId = user? user._id : null;
        if (!!config.apiKey) {
            setUserId(this.analytics, this.userId);
        }
    }

    /**
     *
     * @param event     event=login, page_view, click, etc
     * @param params    action="enter input email", customField=value
     */
    sendLog(event, params) {
        let dataLog = {
            org_id: this.orgId,
            app_name: this.appName,
            app_version: this.appVersion
        }

        if (params) {
            dataLog = Object.assign(dataLog, params);
        }

        if (!!config.apiKey) {
            logEvent(this.analytics, event, dataLog);
        }
    }
}

const AuditTrail = (() => {
    return new AuditTrailService();
})();

export default AuditTrail;

export const PAGES = {
    PAGE_VIEW: 'page_view',
    LOGIN: 'login',
    RESET_PASSWORD: 'reset_password',
    RECOVER_PASSWORD: 'recover_password',
    ACTIVATE_ACCOUNT: 'activate_account',
    UNLOCK_ACCOUNT: 'unlock_account',
    PROGRAM_LIST: 'program_list',
    PROGRAM_DETAIL: 'program_detail',
    PROGRAM_CREATE: 'program_create',
    PROGRAM_EDIT: 'program_edit',
    PROGRAM_PARTICIPANTS: 'program_participants',
    PROGRAM_USERS: 'program_users',
    PROGRAM_TEAMS: 'program_teams',
    PARTICIPANTS_LIST: 'participants_list',
    PARTICIPANTS_CREATE: 'participants_create',
    PARTICIPANTS_EDIT: 'participants_edit',
    PARTICIPANTS_DETAIL: 'participants_detail',
    USERS_LIST: 'users_list',
    USERS_CREATE: 'users_create',
    USERS_EDIT: 'users_edit',
    USERS_DETAIL: 'users_detail',
    TEAMS_LIST: 'teams_list',
    TEAMS_CREATE: 'teams_create',
    TEAMS_EDIT: 'teams_edit',
    TEAMS_DETAIL: 'teams_detail',
    TEAMS_MANAGE: 'teams_manage',
    DEVICE_LIST: 'devices_list',
    DEVICE_TYPE_LIST: 'devices_type_list',
    DEVICE_KIT_LIST: 'devices_kit_list',
    MODAL_REMOVE_TEAM: 'modal_remove_team',
    MODAL_RENAME_TEAM: 'modal_rename_team',
    MODAL_MANAGE_MEMBERS_TEAM: 'modal_manage_members_team'
}
